import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Invoice } from '../interfaces/invoice.interface';
import { Router } from '@angular/router'; 
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private invoicesUrl = environment.apiUrl + '/handlers/invoicesgetall.php';  // URL to web api
  private updateinvoiceUrl = environment.apiUrl + '/handlers/invoiceupdate.php';
  private deleteinvoiceUrl = environment.apiUrl + '/handlers/invoicedelete.php'
  private createinvoiceUrl = environment.apiUrl + '/handlers/invoicecreate.php';

  invoices: Invoice[] = [];
  selectedInvoice: Invoice = {} as Invoice;
  
  constructor(private http: HttpClient, private router: Router) { }

    async getInvoices(datelimit: string): Promise<Invoice[]> 
    {
      let cuser = localStorage.getItem('currentUser');
      if (cuser === null) {
            throw new Error('Not logged in');
      }
      let user = JSON.parse(cuser);
      let distid = user['distid'];
      const data$ = this.http.post<Invoice[]>(this.invoicesUrl,JSON.stringify({ distid: distid, datelimit: datelimit }));
      try {
        this.invoices = await firstValueFrom(data$);
        return this.invoices;
      }
      catch (error) {
        console.error('There was an error!', error);
        throw error;
      };  
    }

async create(customercode:string,productcode:string,employeecode:string,shiptoaddressserial:number,invoiceno:string,invoicedate:string,warehousecode:string,schemecode:string,volumesold:number,volumeid:string,grossturnover:number,cogs:number,producttype:string,lineno:number,customerpo:string,discount:number,creationdate:string,modifieddate:string,netturnover:number,supplierorderno:string,orderdate:string,deliverynoteno:string,deliverynotedate:string,retaildealerid:string,refinvoicenocredit:string,reflinenocreditnote:number,uploaded:string): Promise<any> {
       let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createinvoiceUrl, JSON.stringify({customercode:customercode,productcode:productcode,employeecode:employeecode,shiptoaddressserial:shiptoaddressserial,invoiceno:invoiceno,invoicedate:invoicedate,warehousecode:warehousecode,schemecode:schemecode,volumesold:volumesold,volumeid:volumeid,grossturnover:grossturnover,cogs:cogs,producttype:producttype,lineno:lineno,customerpo:customerpo,discount:discount,creationdate:creationdate,modifieddate:modifieddate,netturnover:netturnover,supplierorderno:supplierorderno,orderdate:orderdate,deliverynoteno:deliverynoteno,deliverynotedate:deliverynotedate,retaildealerid:retaildealerid,refinvoicenocredit:refinvoicenocredit,reflinenocreditnote:reflinenocreditnote,uploaded:uploaded, distid: distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'There was an error!', error);
             return;
         };  
}

    async updateInvoice(customercode:string,productcode:string,employeecode:string,shiptoaddressserial:number,invoiceno:string,invoicedate:string,warehousecode:string,schemecode:string,volumesold:number,volumeid:string,grossturnover:number,cogs:number,producttype:string,lineno:number,customerpo:string,discount:number,creationdate:string,modifieddate:string,netturnover:number,supplierorderno:string,orderdate:string,deliverynoteno:string,deliverynotedate:string,retaildealerid:string,refinvoicenocredit:string,reflinenocreditnote:number, uploaded:string, id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        try {
          const response$ = await firstValueFrom(this.http.post(this.updateinvoiceUrl, JSON.stringify({customercode:customercode,productcode:productcode,employeecode:employeecode,shiptoaddressserial:shiptoaddressserial,invoiceno:invoiceno,invoicedate:invoicedate,warehousecode:warehousecode,schemecode:schemecode,volumesold:volumesold,volumeid:volumeid,grossturnover:grossturnover,cogs:cogs,producttype:producttype,lineno:lineno,customerpo:customerpo,discount:discount,creationdate:creationdate,modifieddate:modifieddate,netturnover:netturnover,supplierorderno:supplierorderno,orderdate:orderdate,deliverynoteno:deliverynoteno,deliverynotedate:deliverynotedate,retaildealerid:retaildealerid,refinvoicenocredit:refinvoicenocredit,reflinenocreditnote:reflinenocreditnote,uploaded:uploaded, distid: distid, id: id})));
           //return response$;
           return;
        }
        catch (error) {
          console.error(
            'Update Customer', error);
            throw error;
        };
    }
    async delete(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deleteinvoiceUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'Delete Invoice Error: ', error);
              throw error;
    };  
   }  

}
